import React from 'react';
import {Route, Switch, BrowserRouter, Redirect} from 'react-router-dom';

// pages
import SearchPage from '../pages/SearchPage/SearchPage';
import CartPage from '../pages/CartPage/CartPage';
import StatisticsPage from '../pages/StatisticsPage/StatisticsPage';
import OrdersPage from '../pages/OrdersPage/OrdersPage';
import DocumentsPage from '../pages/DocumentsPage/DocumentsPage';
import TyrePage from '../pages/TyrePage/TyrePage';

// Admin pages
import NotificationsPage from '../pages/NotificationsPage/NotificationsPage';
import PriceListsPage from '../pages/PriceListsPage/PriceListsPage';
import AdminDocumentsPage from '../pages/AdminDocumentsPage/AdminDocumentsPage';

// routes
import routeSearchPage from '../pages/SearchPage/route';
import routeCartPage from '../pages/CartPage/route';
import routeStatisticsPage from '../pages/StatisticsPage/route';
import routeOrdersPage from '../pages/OrdersPage/route';
import routeDocumentsPage from '../pages/DocumentsPage/route';
import routeTyrePage from '../pages/TyrePage/route';

// Admin routes
import routeNotificationsPage from '../pages/NotificationsPage/route';
import routePriceListsPage from '../pages/PriceListsPage/route';
import routeAdminDocumentsPage from '../pages/AdminDocumentsPage/route';

// AuthCallback
import AuthCallbackPage from '../auth/pages/AuthCallbackPage/AuthCallbackPage';
import routeAuthCallback from '../auth/pages/AuthCallbackPage/route';

// PerformAuth
import PerformAuthPage from '../auth/pages/PerformAuthPage/PerformAuthPage';
import routePerformAuth from '../auth/pages/PerformAuthPage/route';

// Loading
import LoadingPage from '../layout/pages/LoadingPage/LoadingPage';
import routeLoading from '../layout/pages/LoadingPage/route';

// Admin Route Protection
import AdminRoute from './AdminRoute';

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path={routeSearchPage()} component={SearchPage} />
      <Route exact path={routeTyrePage()} component={TyrePage} />
      <Route exact path={routeCartPage()} component={CartPage} />
      <Route exact path={routeDocumentsPage()} component={DocumentsPage} />
      <Route exact path={routeOrdersPage()} component={OrdersPage} />
      
      {/* Admin-only routes */}
      <AdminRoute exact path={routeStatisticsPage()} component={StatisticsPage} />
      <AdminRoute exact path={routeNotificationsPage()} component={NotificationsPage} />
      <AdminRoute exact path={routePriceListsPage()} component={PriceListsPage} />
      <AdminRoute exact path={routeAdminDocumentsPage()} component={AdminDocumentsPage} />
      
      {/* Auth routes */}
      <Route exact path={routeAuthCallback()} component={AuthCallbackPage} />
      <Route exact path={routePerformAuth()} component={PerformAuthPage} />
      <Route exact path={routeLoading()} component={LoadingPage} />
      
      {/* Redirects */}
      <Redirect from="/home" to={routeSearchPage()} />
      <Redirect exact from="/" to={routeSearchPage()} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
